module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"https://www.festivalconcertsearch.com","short_name":"https://www.festivalconcertsearch.com","start_url":"/","background_color":"#000000","theme_color":"#ffffff","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"db3df13d9446e4e2bfc4d6375278fc78"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
